import React, { useState } from 'react'
import styled from 'styled-components'
import { Tooltip } from '@mui/material'
import Modal from 'components/Modal'
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove'
import Button from 'components/Button'
import { useDispatch } from 'react-redux'
import { markStudentAsNew } from 'services/StudentsService'
import { getActiveStudentsRoutine } from 'modules/students/ducks/actions'
import { isNotNilOrEmpty } from 'utils/ramda'

const MoveToNewStudentsModal = ({ student, actionCallback }) => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const handleOpen = e => {
    e.stopPropagation()
    setOpen(true)
  }
  const handleClose = e => {
    e && e.stopPropagation()
    setOpen(false)
  }

  const handleConfirm = () => {
    markStudentAsNew({
      student,
      callback: () => {
        setOpen(false)
        isNotNilOrEmpty(actionCallback) ? actionCallback() : dispatch(getActiveStudentsRoutine())
      }
    })
  }

  return (
    <>
      <Trigger onClick={handleOpen}>
        <Tooltip title='Przenieś do fioletów'>
          <span>
            <StyledIcon />
          </span>
        </Tooltip>
      </Trigger>
      <Modal
        title='Przenieś do fioletów'
        open={open}
        onClose={handleClose}
      >
        <p>
          Czy na pewno chcesz przenieść ucznia <StudentName>{student.name}</StudentName> na listę fioletów?
          Pojawi się w sekcji Fiolety.
        </p>
        <ButtonsWrapper>
          <Button onClick={handleClose} color='secondary'>Anuluj</Button>
          <Button color='primary' onClick={handleConfirm}>Przenieś</Button>
        </ButtonsWrapper>
      </Modal>
    </>
  )
}

export default MoveToNewStudentsModal

const Trigger = styled.div`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
`

const StyledIcon = styled(DriveFileMoveIcon)`
  transition: all .3s;

  &:hover {
    color: ${({ theme }) => theme.colors.secondary.main};
  }
`

const StudentName = styled.strong`
  font-weight: 600;
`

const ButtonsWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 24px;
`
